module.exports = __webpack_public_path__ + "img/j3.e464e646.jpg";